import { observer } from 'mobx-react';
import { useStore } from '../../state/MobxContext';
import Box from '@mui/material/Box';
import { Button } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import CloverleafImage from '../Main/image/Cloverleaf.png';
import blackWallet from '../Main/image/WalletB.png';
import DialogContent from '@mui/material/DialogContent';
// import { useNavigate } from 'react-router-dom';
import MiningB from '../Main/image/채굴.png';
import { TextField } from '@mui/material';
import { makeStyles, useMediaQuery } from "@material-ui/core";
import Dicon from '../Main/image/Icon256.png';
import { Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import Grid from "@mui/material/Grid/Grid";
import EtherImage from '../Main/image/2089411.png';
import DImage from "../Main/image/Icon256.png"












function DBCoinTransfer() {
    const { loginStore } = useStore();
    const { CoinStore } = useStore();
    // const { MiningStore } = useStore();
    // const and = " & ";


    // const navigate = useNavigate();

    const useStyles = makeStyles((theme) => ({
        //Dialog
        Dialog: {
            width: '450px',
            height: "500px"
        },
        DialogMobile: {
            height: '65%',
            width: '80%',
            minWidth: "320px",
            padding: '0'
        },
        //blackWallet
        blackWallet: {
            flex: 1,
            width: '8%',
            height: '8%',
            marginBottom: '-15px',
            objectFit: 'contain',
        },
        blackWalletMobile: {
            width: '10%',
            height: '10%',
            marginBottom: '-15px'
        },
        //CloverleafImage
        CloverleafImage: {
            width: "50px",
            height: "50px",
            marginLeft: '-15px',
            marginTop: '10px'
        },
        CloverleafImageMobile: {
            flex: 1,
            width: '55%',
            height: '55%',
            objectFit: 'contain',
            marginLeft: '-35px',
            marginTop: '10px'
        },
        //DialogContent
        DialogContent: {
            width: '100%',
            height: "100%",
        },
        DialogContentMobile: {
            overflow: 'auto',
        },

        //TextWalletLocation
        TextWalletLocation: {
            // backgroundColor: 'blue',
            width: '100%',
            height: "40%",
            marginLeft: '-300px',
            marginTop: '20px'
        },
        TextWalletLocationMobile: {
            width: '100%',
            height: "40%",
            marginLeft: '-160px',
            marginTop: '20px'
        },
        //XLocation
        XLocation: {
            width: '15%',
            height: "40%",
            marginTop: '20px'
        },
        XLocationMobile: {
            width: '20%',
            height: "40%",
            marginTop: '20px'
        },
        //DiconImage
        MiningBImage: {
            width: '15%',
            marginRight: '5%',
            marginLeft: '-17%'
        },
        MiningBImageMobile: {
            width: '15%',
            height: 'auto',
            marginLeft: '-5%'
        },
        //MiningBCountLocation
        MiningBCountLocation: {
            marginLeft: '-15px',
            marginBottom: '-7px'
        },
        MiningBCountLocationMobile: {
            marginLeft: '0.9%',
            marginBottom: '-7px'
        },
        //Dicon
        Dicon: {
            width: '8%',
            marginLeft: '-13%'
        },
        DiconMobile: {
            width: '10%',
            marginLeft: '-2%'
        },
        //DiconCountLocation
        DiconCountLocation: {
            marginLeft: '11px',
            marginBottom: '-7px'
        },
        DiconCountLocationMobile: {
            marginLeft: '3%',
            marginBottom: '-7px'
        },
        //CommissionMiningImage
        CommissionMiningImage: {
            width: '15%',
            height: '50%',
        },
        CommissionMiningImageMobile: {
            width: '15%',
            height: '20%',
            marginTop: "3%"
            // marginLeft:'10%'
        },
        // CommissionMiningImageLocation
        CommissionMiningImageLocation: {
            // marginLeft: '-10%',
            marginTop: '1%'
        },
        CommissionMiningImageLocationMobile: {
            marginLeft: '-8%'
        },
        //EtherCountLocation
        EtherCountLocation: {
            // marginLeft: '-86%',
            marginBottom: '0px'
        },
        EtherCountLocationMobile: {
            marginLeft: '-100%',
            marginRight: '-13%',
            marginBottom: '0px'
        },
        //sendEtherImage
        sendEtherImage: {
            width: '7%',
            height: '60%',
            marginLeft: 'px'
        },
        sendEtherImageMobile: {
            width: '6%',
            height: '45%',
            marginLeft: '35px',
            marginTop: '5px'
        },
        //sendEtherImageLocation
        sendEtherImageLocation: {
            marginLeft: '-10px',
            padingRight: '-50px'
        },
        sendEtherImageLocationMobile: {
            marginLeft: '-40px',
        },
        //CommissionTextLocation
        CommissionTextLocation: {
            width: '100%',
            height: "100%",
        },
        CommissionTextLocationMobile: {
            width: '100%',
            height: "100%",
        },
    }));

    const classes = useStyles();
    const isMobile = useMediaQuery("(max-width: 600px)");
    const DBCoinTransferButton = loginStore?.isDBCoinTransferButton;
    const GuideWallet = CoinStore?.GuideWallet;
    const GuideStand = CoinStore?.GuideStand;
    const CommissionEther = CoinStore?.Commission;
    const SendButton = CoinStore?.SendButtonChange;
    const GuideEtherCoin = CoinStore?.GuideEtherCoin;
    const FeeMessage = CoinStore?.GuideTransferMessage;

    const calculationCoinChange = CoinStore?.CalculationCoinChange;
    // console.log(calculationCoinChange);

    // const ExchangeMemberStandData = CoinStore.ExchangeMemberStandData;
    const CoinTransferData = CoinStore?.CoinTransferData;


    let isDBCoinTransferPage = CoinStore?.isDBCoinTransferPage;
    let isStandExchangePage = CoinStore?.isStandExchangePage;


    // const calculationCoin = Number(CoinStore.DBData) - Number(CoinTransferData);
    // const calculationCoinChange = String(calculationCoin);
    // const calculationCoinChangeNaN = Number.isNaN(calculationCoin);


    let CoinData = CoinStore?.StandData;

    let DBExchangeDataValue = CoinStore?.DBExchangeDataValue;
    // let DBExchangeCommission = CoinStore?.DBExchangeCommission;
    let RealTokenToDBCommission = CoinStore?.RealTokenToDBCommission;
    // console.log(CoinTransferData);


    let Guide_clover_allPage_01 = loginStore?.Guide_clover_allPage_01; //지갑주소를 입력해주세요
    let Guide_clover_allPage_02 = loginStore?.Guide_clover_allPage_02; //수량을 입력해 주세요
    let Guide_clover_allPage_03 = loginStore?.Guide_clover_allPage_03; //수수료확인
    let Guide_clover_allPage_05 = loginStore?.Guide_clover_allPage_05; //보내기
    let Guide_clover_dialog_DBCoinTransfer_01 = loginStore?.Guide_clover_dialog_DBCoinTransfer_01; //코인 전환
    let Guide_clover_dialog_DBCoinTransfer_02 = loginStore?.Guide_clover_dialog_DBCoinTransfer_02; //All
    let Guide_clover_dialog_DBCoinTransfer_03 = loginStore?.Guide_clover_dialog_DBCoinTransfer_03; //수수료









    const WhiteTextTypography = withStyles({
        root: {
            color: "#FFFFFF",
            fontSize: "1.5rem"


        }
    })(Typography);

    const WhiteButtonTextTypography = withStyles({
        root: {
            color: "#FFFFFF",
            fontSize: "1rem"


        }
    })(Typography);

    const CoinTextTypography = withStyles({
        root: {
            fontSize: "1.5rem"
        }
    })(Typography);

    const ExchangecommissionTextTypography = withStyles({
        root: {
            fontSize: "1rem"
        }
    })(Typography);

    const CoinTextMovileTypography = withStyles({
        root: {
            fontSize: "0.8rem"
        }
    })(Typography);


    const ExchangeCoinTextMovileTypography = withStyles({
        root: {
            fontSize: "0.6rem"
        }
    })(Typography);

    const isMiningTransformDialogOpen = loginStore?.isMiningTransformDialogOpen;

    // console.log(isMiningTransformDialogOpen);
    return (
        <div>
            <Dialog classes={isMobile ? { paper: classes.DialogMobile } : { paper: classes.Dialog }} maxWidth="xl" open={isMiningTransformDialogOpen} onClose={loginStore.setDialogClose()}>
                <Box sx={isMobile ? { display: 'flex', bgcolor: 'black', width: 'auto', maxWidth: '600px', height: '60px', } : { display: 'flex', bgcolor: 'black', width: '100%', maxWidth: '600px', height: '70px', }}>
                    <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row' justifyContent='space-between' alignItems='center' >
                        <Grid container item xs={11} sm={11} md={11} lg={11} xl={11} alignItems="flex-end"  >
                            <img src={CloverleafImage} width="50" height="50" alt="Cloverleaf" />
                            <WhiteTextTypography > {Guide_clover_dialog_DBCoinTransfer_01}</WhiteTextTypography>
                        </Grid>
                        <Grid container item xs={1} sm={1} md={1} lg={1} xl={1}>
                            <FontAwesomeIcon icon={faXmark} color='White' size='2x' onClick={(e) => { loginStore.setDialogClose("MiningTransformFalse") }} />
                        </Grid>
                    </Grid>
                </Box>
                <Box>
                    <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row' justifyContent='center' alignItems='center' paddingLeft="0px" position='sticky' top={0} >
                        <Grid item xs={6} sm={6} md={6} lg={6} xl={6} >
                            <Button style={isMobile ? { maxWidth: '100%', maxHeight: '100%', minWidth: '100%', minHeight: '100%', fontSize: 20 }
                                : { maxWidth: '100%', maxHeight: '100%', minWidth: '100%', minHeight: '100%', fontSize: 20 }}
                                variant="contained" color='inherit' onClick={(e) => { CoinStore?.setisDBCoinTransfer("DBCoinTransfer", true) }} >채굴 환전</Button>
                        </Grid>
                        <Grid item xs={6} sm={6} md={6} lg={6} xl={6} >
                            <Button style={isMobile ? { maxWidth: '100%', maxHeight: '100%', minWidth: '100%', minHeight: '100%', fontSize: 20 }
                                : { maxWidth: '100%', maxHeight: '100%', minWidth: '100%', minHeight: '100%', fontSize: 20 }}
                                variant="contained" color='inherit' onClick={(e) => { CoinStore?.setisDBCoinTransfer("StandExchange", true) }} >환전</Button>
                        </Grid>
                    </Grid>
                </Box>
                {/* <Box>
                    <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row' justifyContent="center" alignItems="center"
                        sx={{ backgroundColor: 'black' }}>
                        <Grid container item xs={6} sm={6} md={6} lg={6} xl={6} direction='row' justifyContent="center" alignItems="center">
                            <Button onClick={CoinStore?.setisDBCoinTransfer("DBCoinTransfer", true)}>
                                <WhiteButtonTextTypography>
                                    채굴 환전
                                </WhiteButtonTextTypography>
                            </Button>
                        </Grid>
                        <Grid container item xs={6} sm={6} md={6} lg={6} xl={6} direction='row' justifyContent="center" alignItems="center">
                            <Button onClick={CoinStore?.setisDBCoinTransfer("StandExchange", true)}>
                                <WhiteButtonTextTypography>
                                    환전
                                </WhiteButtonTextTypography>
                            </Button>
                        </Grid>
                    </Grid>
                </Box> */}
                <DialogContent >
                    {isDBCoinTransferPage === true &&
                        <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='column'>
                            {DBCoinTransferButton === 0 &&
                                <Grid item xs={8} sm={8} md={8} lg={8} xl={8} >
                                    <Box sx={isMobile ? { border: 1, margin: '-5px', marginTop: '0px' } : { border: 1, marginTop: '0px', paddingBottom: "5%" }} >
                                        <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='column' spacing={2} >
                                            <Grid item xs={2} sm={2} md={2} lg={2} xl={2} marginTop='20px'>
                                                <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row'>
                                                    <Grid container item xs={2} sm={2} md={2} lg={2} xl={2} direction='row' alignItems='center' justifyContent='flex-end' >
                                                        {/* <Typography  style={isMobile ? {fontSize: 10} : {fontSize: 15}}  variant={ isMobile ? "subtitle1" : "h5" }>수수료</Typography> */}
                                                    </Grid>
                                                    <Grid container item xs={8} sm={8} md={8} lg={8} xl={8} direction='row' alignItems='center' justifyContent='flex-start' paddingBottom="5%">
                                                        <Box sx={{ borderBottom: 1 }}>
                                                            <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row' alignItems='center' justifyContent='flex-start'>
                                                                <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                                                                    <img src={MiningB} style={{ width: '100%', height: 'auto' }} alt='MiningB' />
                                                                </Grid>
                                                                <Grid item xs={10} sm={10} md={10} lg={10} xl={10}>
                                                                    {isMobile ?
                                                                        <CoinTextMovileTypography >{CoinStore?.DBData !== undefined ? CoinStore?.DBData : '00000000.00000000'}</CoinTextMovileTypography>
                                                                        :
                                                                        <CoinTextTypography >{CoinStore?.DBData !== undefined ? CoinStore?.DBData : '00000000.00000000'}</CoinTextTypography>
                                                                    }
                                                                </Grid>
                                                            </Grid>
                                                        </Box>
                                                    </Grid>
                                                    <Grid item xs={2} sm={2} md={2} lg={2} xl={2} />
                                                </Grid>
                                            </Grid>
                                            <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                                                <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row' justifyContent='center' alignItems='center' paddingBottom="5%">
                                                    <Grid item xs={2} sm={2} md={2} lg={2} xl={2} />
                                                    <Grid container item xs={8} sm={8} md={8} lg={8} xl={8} direction='row' alignItems='center' justifyContent='flex-start'>
                                                        <Box sx={{ display: "flex", borderBottom: 1 }}>
                                                            <TextField
                                                                variant="standard"
                                                                label=""
                                                                type="number"
                                                                InputProps={{
                                                                    startAdornment: <img style={{ width: '10%', height: 'auto' }} src={Dicon} alt='StandImage' />
                                                                }}
                                                                inputProps={isMobile ? { min: 0, style: { textAlign: 'center', fontSize: 13 } } : { min: 0, style: { textAlign: 'center' } }}
                                                                fullWidth
                                                                // placeholder={TransformStandValue}
                                                                // dtefaulValue={calculationCoinChange}
                                                                value={calculationCoinChange}
                                                                // onClick={(e)=>{CoinStore.WalletTextclick(e)}}
                                                                onChange={(e) => { CoinStore.setUserCalculationCoinChange(e) }}
                                                            />
                                                            {/* <img style={{width:'10%', height:'auto',paddingRight:'7px',paddingLeft:'10px'}} src={Dicon} alt='StandImage' />
                                                    <CoinTextTypography variant={ isMobile ? "subtitle1" : "h5" }>.{StandCount !== undefined ? StandCount : '00000000.00000000' }</CoinTextTypography> */}
                                                        </Box>
                                                    </Grid>
                                                    <Grid container item xs={2} sm={2} md={2} lg={2} xl={2} direction='row' alignItems='center' justifyContent='center' >
                                                        <Button variant="contained" color='inherit'
                                                            style={{ maxWidth: '70%', maxHeight: '70%', minWidth: '70%', minHeight: '70%', fontSize: 10 }}
                                                            onClick={(e) => { CoinStore.getExchangeCommissions("All") }}
                                                        >
                                                            {Guide_clover_dialog_DBCoinTransfer_02}
                                                        </Button>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                            <Grid item xs={2} sm={2} md={2} lg={2} xl={2} >
                                                <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row'>
                                                    <Grid container item xs={2} sm={2} md={2} lg={2} xl={2} direction='row' alignItems='center' justifyContent='flex-end' paddingBottom="5%" >
                                                        <Typography style={isMobile ? { fontSize: 10 } : { fontSize: 15 }} variant={isMobile ? "subtitle1" : "h5"} >
                                                            {Guide_clover_dialog_DBCoinTransfer_03}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid container item xs={8} sm={8} md={8} lg={8} xl={8} direction='row' alignItems='center' justifyContent='flex-start' paddingBottom="5%" >
                                                        <Box sx={{ borderBottom: 1 }}>
                                                            <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row' alignItems='center' justifyContent='flex-start'>
                                                                <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                                                                    <img src={MiningB} style={{ width: '100%', height: 'auto' }} alt='MiningB' />
                                                                </Grid>
                                                                <Grid item xs={10} sm={10} md={10} lg={10} xl={10}>
                                                                    {isMobile ?
                                                                        <CoinTextMovileTypography >
                                                                            {
                                                                                CoinTransferData !== undefined ?
                                                                                    CoinTransferData !== null ?
                                                                                        CoinTransferData !== "" ?
                                                                                            CoinTransferData
                                                                                            :
                                                                                            '00000000.00000000'
                                                                                        :
                                                                                        '00000000.00000000'
                                                                                    :
                                                                                    '00000000.00000000'}
                                                                        </CoinTextMovileTypography>
                                                                        :
                                                                        <CoinTextTypography >
                                                                            {
                                                                                CoinTransferData !== undefined ?
                                                                                    CoinTransferData !== null ?
                                                                                        CoinTransferData !== "" ?
                                                                                            CoinTransferData
                                                                                            :
                                                                                            '00000000.00000000'
                                                                                        :
                                                                                        '00000000.00000000'
                                                                                    :
                                                                                    '00000000.00000000'}
                                                                        </CoinTextTypography>
                                                                    }
                                                                </Grid>
                                                            </Grid>
                                                        </Box>
                                                    </Grid>
                                                    <Grid item xs={2} sm={2} md={2} lg={2} xl={2} />
                                                </Grid>
                                            </Grid>
                                            <Grid item xs={2} sm={2} md={2} lg={2} xl={2} marginTop="-10px" >
                                                <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row'>
                                                    <Grid item xs={2} sm={2} md={2} lg={2} xl={2} />
                                                    <Grid container item xs={8} sm={8} md={8} lg={8} xl={8} direction='row' alignItems='center' justifyContent='center'>
                                                        <Typography>
                                                            {FeeMessage}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={2} sm={2} md={2} lg={2} xl={2} />
                                                </Grid>
                                            </Grid>
                                            <Grid item xs={2} sm={2} md={2} lg={2} xl={2} >
                                                <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row'>
                                                    <Grid item xs={2} sm={2} md={2} lg={2} xl={2} />
                                                    <Grid container item xs={8} sm={8} md={8} lg={8} xl={8} direction='row' alignItems='center' justifyContent='center'>
                                                        <Button variant="contained" color='inherit' style={isMobile ? { maxWidth: '100%', maxHeight: '100%', minWidth: '100%', minHeight: '100%', fontSize: 20 }
                                                            : { maxWidth: '100%', maxHeight: '100%', minWidth: '100%', minHeight: '100%', fontSize: 20 }}
                                                            onClick={(e) => { CoinStore.setExchangeMemberStand(e) }}
                                                        >
                                                            {Guide_clover_dialog_DBCoinTransfer_01}
                                                        </Button>
                                                    </Grid>
                                                    <Grid item xs={2} sm={2} md={2} lg={2} xl={2} />
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Box>
                                </Grid>
                            }
                            {DBCoinTransferButton === 1 &&
                                <Grid item xs={8} sm={8} md={8} lg={8} xl={8} >
                                    <Box sx={isMobile ? { border: 1, margin: '-5px', marginTop: '0px' } : { border: 1, marginTop: '0px' }} >
                                        <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='column' spacing={2} >
                                            <Grid item xs={2} sm={2} md={2} lg={2} xl={2} marginTop="20px" >
                                                <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row' justifyContent='center' alignItems='center'>
                                                    {/* <Grid item xs={2} sm={2} md={2} lg={2} xl={2}/> */}
                                                    <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} mx='10px' direction='row' alignItems='flex-end' justifyContent='flex-start' >
                                                        <Grid item xs={1} sm={1} md={1} lg={1} xl={1}>
                                                            <img src={blackWallet} style={{ width: '70%', height: '70%' }} alt='blackWallet' />
                                                        </Grid>
                                                        <Grid item xs={11} sm={11} md={11} lg={11} xl={11}>
                                                            <TextField
                                                                variant="standard"
                                                                label={Guide_clover_allPage_01}
                                                                inputProps={isMobile ? { min: 0, style: { textAlign: 'center', fontSize: 13 } } : { min: 0, style: { textAlign: 'center' } }}
                                                                fullWidth
                                                                placeholder={GuideWallet}
                                                                // onClick={(e)=>{CoinStore.WalletTextclick(e)}}
                                                                onChange={(e) => { CoinStore.WalletTextValue(e) }}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                    {/* <Grid item xs={2} sm={2} md={2} lg={2} xl={2} /> */}
                                                </Grid>
                                            </Grid>
                                            <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row' justifyContent='center' alignItems='center' >
                                                {/* <Grid item xs={2} sm={2} md={2} lg={2} xl={2}/> */}
                                                <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} mx='10px' direction='row' alignItems='flex-end' justifyContent='flex-start' >
                                                    <Grid item xs={1} sm={1} md={1} lg={1} xl={1} >
                                                        <img src={EtherImage} style={{ width: '70%', height: '70%' }} alt='EtherImage' />
                                                    </Grid>
                                                    <Grid item xs={11} sm={11} md={11} lg={11} xl={11} >
                                                        <TextField
                                                            disabled
                                                            variant="standard"
                                                            // label={CommissionEther}
                                                            inputProps={isMobile ? { min: 0, style: { textAlign: 'center', fontSize: 10 } } : { min: 0, style: { textAlign: 'center', fontSize: 15 } }}
                                                            FormHelperTextProps={isMobile ?
                                                                { min: 0, style: { textAlign: 'center', fontSize: 10, color: 'red' } } : { min: 0, style: { textAlign: 'center', fontSize: 15, color: 'red' } }}
                                                            fullWidth
                                                            value={GuideEtherCoin}
                                                        // helperText={CoinStore.GuideCommission}
                                                        />
                                                    </Grid>
                                                </Grid>
                                                {/* <Grid item xs={2} sm={2} md={2} lg={2} xl={2} /> */}
                                            </Grid>
                                            <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row' justifyContent='center' alignItems='center'>
                                                {/* <Grid item xs={2} sm={2} md={2} lg={2} xl={2}/> */}
                                                <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} mx='10px' direction='row' alignItems='flex-end' justifyContent='flex-start' marginTop="-10px">
                                                    <Grid item xs={1} sm={1} md={1} lg={1} xl={1} >
                                                        <img src={MiningB} style={{ width: '100%', height: '100%', marginLeft: '-15%' }} alt='MiningB' />
                                                    </Grid>
                                                    <Grid item xs={11} sm={11} md={11} lg={11} xl={11} >
                                                        <TextField
                                                            type='number'
                                                            variant="standard"
                                                            label={Guide_clover_allPage_02}
                                                            inputProps={isMobile ? { min: 0, style: { textAlign: 'center', fontSize: 13 } } : { min: 0, style: { textAlign: 'center' } }}
                                                            fullWidth
                                                            placeholder={GuideStand}
                                                            // onClick={()=>{CoinStore.StandTextclick()}}
                                                            onChange={(e) => { CoinStore.StandTextValue(e) }}
                                                        />
                                                    </Grid>
                                                </Grid>
                                                {/* <Grid item xs={2} sm={2} md={2} lg={2} xl={2} /> */}
                                            </Grid>
                                            <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row' justifyContent='center' alignItems='center' >
                                                {/* <Grid item xs={2} sm={2} md={2} lg={2} xl={2}/> */}
                                                <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} mx='10px' direction='row' alignItems='flex-end' justifyContent='flex-start' >
                                                    <Grid item xs={1} sm={1} md={1} lg={1} xl={1} >
                                                        <img src={EtherImage} style={{ width: '70%', height: '70%' }} alt='EtherImage' />
                                                    </Grid>
                                                    <Grid item xs={11} sm={11} md={11} lg={11} xl={11} >
                                                        <TextField
                                                            disabled
                                                            variant="standard"
                                                            // label={CommissionEther}
                                                            inputProps={isMobile ? { min: 0, style: { textAlign: 'center', fontSize: 10 } } : { min: 0, style: { textAlign: 'center', fontSize: 15 } }}
                                                            FormHelperTextProps={isMobile ?
                                                                { min: 0, style: { textAlign: 'center', fontSize: 10, color: 'red' } } : { min: 0, style: { textAlign: 'center', fontSize: 15, color: 'red' } }}
                                                            fullWidth
                                                            value={CommissionEther}
                                                            helperText={CoinStore?.GuideCommission}
                                                        />
                                                    </Grid>
                                                </Grid>
                                                {/* <Grid item xs={2} sm={2} md={2} lg={2} xl={2} /> */}
                                            </Grid>
                                            <Grid item xs={2} sm={2} md={2} lg={2} xl={2} >
                                                <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row'>
                                                    <Grid item xs={2} sm={2} md={2} lg={2} xl={2} />
                                                    <Grid container item xs={8} sm={8} md={8} lg={8} xl={8} direction='row' alignItems='center' justifyContent='center' marginTop="10px">
                                                        {SendButton === 0 ?
                                                            <Button variant="contained" color='inherit' size="medium"
                                                                style={isMobile ? { maxWidth: '100%', maxHeight: '100%', minWidth: '100%', minHeight: '100%', fontSize: 20 }
                                                                    : { maxWidth: '100%', maxHeight: '100%', minWidth: '100%', minHeight: '100%', fontSize: 20 }} onClick={(e) => { CoinStore.getCommissionEther() }} >{Guide_clover_allPage_03}</Button>
                                                            :
                                                            <Button variant="contained" color='inherit' size="medium"
                                                                style={isMobile ? { maxWidth: '100%', maxHeight: '100%', minWidth: '100%', minHeight: '100%', fontSize: 20 }
                                                                    : { maxWidth: '100%', maxHeight: '100%', minWidth: '100%', minHeight: '100%', fontSize: 20 }} onClick={(e) => { CoinStore.SandCoin() }} >{Guide_clover_allPage_05}</Button>
                                                        }
                                                    </Grid>
                                                    <Grid item xs={2} sm={2} md={2} lg={2} xl={2} />
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Box>
                                </Grid>
                            }
                        </Grid>
                    }
                    {isStandExchangePage === true &&
                        <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='column'>
                            <Box
                                sx={isMobile ? { border: 1, margin: '-5px', marginTop: '0px' } : { border: 1, marginTop: '0px', paddingBottom: "5%", py: "5%" }}
                            >

                                <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row' justifyContent="center" alignItems="center"
                                    sx={{ py: "2%" }}
                                >
                                    <Grid item xs={2} sm={2} md={2} lg={2} xl={2}
                                    // sx={{ bgcolor: "red" }}
                                    >
                                    </Grid>
                                    <Grid container item xs={8} sm={8} md={8} lg={8} xl={8} direction='row' justifyContent="center" alignItems="center"
                                    // sx={{ borderBottom: 1 }}

                                    >
                                        <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row' justifyContent="center" alignItems="center"
                                        >
                                            <Box sx={{ borderBottom: 1 }}>
                                                <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row' alignItems='center' justifyContent='flex-start'>
                                                    <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                                                        <img src={DImage} style={{ width: '70%', height: 'auto' }} alt='DImage' />
                                                    </Grid>
                                                    <Grid item xs={10} sm={10} md={10} lg={10} xl={10}>
                                                        {isMobile ?
                                                            <CoinTextMovileTypography >{CoinData !== undefined ? CoinData : '00000000.00000000'}</CoinTextMovileTypography>
                                                            :
                                                            <CoinTextTypography >{CoinData !== undefined ? CoinData : '00000000.00000000'}</CoinTextTypography>
                                                        }
                                                    </Grid>
                                                </Grid>
                                            </Box>
                                            {/* <TextField
                                                variant="standard"
                                                label=""
                                                // type="number"
                                                InputProps={{
                                                    startAdornment: <img style={{ width: '10%', height: 'auto' }} src={Dicon} alt='StandImage' />
                                                }}
                                                inputProps={isMobile ? { min: 0, style: { textAlign: 'center', fontSize: 13 } } : { min: 0, style: { textAlign: 'center' } }}
                                                fullWidth
                                                // placeholder={TransformStandValue}
                                                // dtefaulValue={CoinData}
                                                value={CoinData}
                                                // onClick={(e)=>{CoinStore.WalletTextclick(e)}}
                                                // onChange={(e) => { CoinStore.setUserCalculationCoinChange(e) }}
                                            /> */}
                                            {/* <Grid item xs={1} sm={1} md={1} lg={1} xl={1}>

                                                <img src={DImage} style={{ width: '100%', height: 'auto' }} alt='DImage' />
                                            </Grid>

                                            <Grid item xs={11} sm={11} md={11} lg={11} xl={11} >

                                                {CoinData}vvv
                                            </Grid> */}


                                        </Grid>
                                    </Grid>
                                    <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>

                                    </Grid>

                                </Grid>
                                <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row' justifyContent="center" alignItems="center"
                                    sx={{ py: "5%" }}
                                >
                                    <Grid container item xs={2} sm={2} md={2} lg={2} xl={2} direction='row' justifyContent="center" alignItems="center" >
                                        {isMobile ?
                                            <ExchangeCoinTextMovileTypography>
                                                {/* {Guide_clover_dialog_DBCoinTransfer_03} */}
                                                환전
                                            </ExchangeCoinTextMovileTypography>

                                            :
                                            <ExchangecommissionTextTypography>
                                                {/* {Guide_clover_dialog_DBCoinTransfer_03} */}
                                                환전
                                            </ExchangecommissionTextTypography>
                                        }
                                        {/* 환전 */}
                                    </Grid>
                                    <Grid item xs={8} sm={8} md={8} lg={8} xl={8}>

                                        <TextField
                                            // label="Size"
                                            id="standard-size-small"
                                            // defaultValue=""
                                            fullWidth
                                            value={DBExchangeDataValue}
                                            onChange={(e) => { CoinStore.setDBExchangeDataValue(e.target.value) }}
                                            size="small"
                                            variant="standard"
                                        />
                                        {/* <Button
                                            variant="contained" color='inherit' size="medium"
                                            style={isMobile ? { maxWidth: '20%', maxHeight: '100%', minWidth: '20%', minHeight: '100%', fontSize: 15 }
                                                : { maxWidth: '20%', maxHeight: '100%', minWidth: '20%', minHeight: '100%', fontSize: 15 }}
                                            onClick={(e) => {
                                                CoinStore?.setDBExchangeDataValue('max')
                                            }}
                                        >
                                            전체
                                        </Button> */}

                                    </Grid>
                                    <Grid container item xs={2} sm={2} md={2} lg={2} xl={2} direction='row' alignItems='center' justifyContent='center' >
                                            <Button variant="contained" color='inherit'
                                                style={{ maxWidth: '70%', maxHeight: '70%', minWidth: '70%', minHeight: '70%', fontSize: 10 }}
                                                onClick={(e) => { CoinStore.setDBExchangeDataValue("max") }}
                                            >
                                                {Guide_clover_dialog_DBCoinTransfer_02}
                                            </Button>
                                        </Grid>
                                    <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>

                                    </Grid>


                                </Grid>
                                 
                                <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row' justifyContent="center" alignItems="center"
                                    sx={{ py: "5%" }}

                                >
                                    <Grid container item xs={2} sm={2} md={2} lg={2} xl={2} direction='row' justifyContent="center" alignItems="center" >
                                        {isMobile ?
                                            <ExchangeCoinTextMovileTypography>
                                                {Guide_clover_dialog_DBCoinTransfer_03}
                                            </ExchangeCoinTextMovileTypography>

                                            :
                                            <ExchangecommissionTextTypography>
                                                {Guide_clover_dialog_DBCoinTransfer_03}
                                            </ExchangecommissionTextTypography>
                                        }

                                    </Grid>
                                    <Grid item xs={8} sm={8} md={8} lg={8} xl={8}>
                                        <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row' justifyContent="center" alignItems="center">
                                            <Box sx={{ borderBottom: 1 }}>
                                                <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row' alignItems='center' justifyContent='flex-start'>
                                                    <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                                                        <img src={DImage} style={{ width: '70%', height: 'auto' }} alt='DImage' />
                                                    </Grid>
                                                    <Grid item xs={10} sm={10} md={10} lg={10} xl={10}>
                                                        {isMobile ?
                                                            <CoinTextMovileTypography >{RealTokenToDBCommission !== undefined ? RealTokenToDBCommission : '00000000.00000000'}</CoinTextMovileTypography>
                                                            :
                                                            <ExchangecommissionTextTypography >{RealTokenToDBCommission !== undefined ? RealTokenToDBCommission : '00000000.00000000'}</ExchangecommissionTextTypography>
                                                        }

                                                    </Grid>
                                                </Grid>
                                            </Box>
                                            {/* <Grid item xs={1} sm={1} md={1} lg={1} xl={1}>

                                                <img src={EtherImage} style={{ width: '70%', height: '70%' }} alt='EtherImage' />

                                            </Grid>

                                            <Grid item xs={11} sm={11} md={11} lg={11} xl={11}>
                                                {DBExchangeCommission}
                                            </Grid> */}

                                        </Grid>
                                    </Grid>
                                    <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>

                                    </Grid>
                                </Grid>

                                <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row' justifyContent="center" alignItems="center"
                                    sx={{ py: "5%" }}

                                >
                                    {/* <Grid item xs={2} sm={2} md={2} lg={2} xl={2} >

                                    </Grid> */}
                                    <Grid item xs={8} sm={8} md={8} lg={8} xl={8}>

                                        <Button
                                            variant="contained" color='inherit' size="medium"
                                            style={isMobile ? { maxWidth: '100%', maxHeight: '100%', minWidth: '100%', minHeight: '100%', fontSize: 20 }
                                                : { maxWidth: '100%', maxHeight: '100%', minWidth: '100%', minHeight: '100%', fontSize: 20 }}
                                            onClick={(e) => { CoinStore?.polygonTokenChangeToDBToken(); }}
                                        >
                                            {Guide_clover_allPage_05}
                                        </Button>
                                        {/* 
                                        {DBExchangeCommission > 0 ?
                                            <Button
                                                variant="contained" color='inherit' size="medium"
                                                style={isMobile ? { maxWidth: '100%', maxHeight: '100%', minWidth: '100%', minHeight: '100%', fontSize: 20 }
                                                    : { maxWidth: '100%', maxHeight: '100%', minWidth: '100%', minHeight: '100%', fontSize: 20 }}

                                                onClick={(e) => { CoinStore?.setDBExchangeValueStand("확인") }}
                                            >
                                                환전
                                            </Button>
                                            :
                                            <Button
                                                variant="contained" color='inherit' size="medium"
                                                style={isMobile ? { maxWidth: '100%', maxHeight: '100%', minWidth: '100%', minHeight: '100%', fontSize: 20 }
                                                    : { maxWidth: '100%', maxHeight: '100%', minWidth: '100%', minHeight: '100%', fontSize: 20 }}
                                                onClick={(e) => { CoinStore?.getDBExchangeValueCommission("수수료") }}
                                            >
                                                {Guide_clover_allPage_03}
                                            </Button>
                                        } */}
                                        <Grid item xs={2} sm={2} md={2} lg={2} xl={2} >

                                        </Grid>
                                    </Grid>
                                </Grid>

                            </Box>

                        </Grid>
                    }

                </DialogContent>
            </Dialog>
        </div>
    );
};

export default observer(DBCoinTransfer);